/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `Task create` - TASK_CREATE
 * * `Task update` - TASK_UPDATE
 */
export enum TriggerKind {
  TASK_CREATE = 'Task create',
  TASK_UPDATE = 'Task update',
}
